import { useTranslation } from 'react-i18next';
import HelpPanel from '../components/help-panel.tsx';
import { useAppConfig } from '../components/turnstile.tsx';
import { Spinner } from '../components/ui.tsx';
import { useSession } from '../state/session.tsx';

export default function HelpPage() {
  const { t } = useTranslation();
  const config = useAppConfig();
  const { company, demoMode } = useSession();
  if (config.isPending)
    return (
      <div role="status">
        <Spinner /> {t('common.loading')}
      </div>
    );
  if (!config.data?.helpAssistant)
    return (
      <div role="alert" className="card">
        <h1 className="text-xl font-bold">{t('help.title')}</h1>
        <p className="mt-3">{t('help.unavailable')}</p>
      </div>
    );
  const locked = company?.accessLocked === true;
  return <HelpPanel showFounderContact={!(demoMode && locked) && company?.accessLockedReason !== 'dormant'} />;
}
